const NETWORKS = { EtWTRABZaYq6iMfeYKouRu166VU2xqa1wcaWoxPkrZBG: 'devnet', '5eykt4UsFv8P8NJdTREpY1vzqKqZKvdpKuc147dw2N9d': 'mainnet-beta' };
const networks = new Map();
export function getPaymentNetwork(connection) {
    const key = connection.rpcEndpoint || connection;
    if (networks.has(key)) return networks.get(key);
    const pending = Promise.resolve().then(() => connection.getGenesisHash()).then(hash => {
        if (!NETWORKS[hash]) throw new Error('Payments require devnet or mainnet-beta.');
        return NETWORKS[hash];
    }).catch(error => { networks.delete(key); throw error; });
    networks.set(key, pending);
    return pending;
}
